import { computed } from 'vue';
import { useStorage } from '@vueuse/core';
import { useRoute } from 'vue-router';
import {
  useLocalPreferencesStore,
  userScopedKey
} from '@/stores/localPreferences';
import { LocalPreferenceKeys } from '@/types/enums/LocalPreferenceKeys';

export function useExpertSettings() {
  const route = useRoute();
  const localPreferencesStore = useLocalPreferencesStore();

  // The public create route is anonymous, so there is no per-user local
  // preference to read or write there — that flow stays session scoped. The key
  // is still scoped by user, because sessionStorage survives the Keycloak
  // redirect: without it, signing out and back in as someone else in the same
  // tab would hand the next user the previous one's toggle.
  const sessionExpertSettings = useStorage(
    userScopedKey(LocalPreferenceKeys.EXPERT_SETTINGS),
    false,
    sessionStorage,
    { initOnMounted: true }
  );

  const isPublicCreateRoute = computed(
    () => route.name === 'p-document-create'
  );

  const expertSettings = computed(() =>
    isPublicCreateRoute.value
      ? sessionExpertSettings.value
      : localPreferencesStore.expertSettings
  );

  function toggleExpertSettings() {
    if (isPublicCreateRoute.value) {
      sessionExpertSettings.value = !sessionExpertSettings.value;
      return;
    }
    localPreferencesStore.expertSettings =
      !localPreferencesStore.expertSettings;
  }

  return {
    expertSettings,
    toggleExpertSettings
  };
}
